// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"bac48889","453":"e2ee1101","580":"63830fb2"}[chunkId] + ".chunk.js";
};